export default __webpack_public_path__ + "static/media/SCB.723aeb84.svg";